const state = {
  list: [],
  selectedRoute: null,
};

const getters = {
  staticRoutes: (state) => state.list,
  selectedRoute: (state) => state.selectedRoute,
};

const actions = {
  async fetchStaticRoutes({ commit }) {
    const response = await this._vm.$http.get(`/restapi/staticroutes`);
    commit("setStaticRoutes", response.data);
  },

  async fetchStaticRoute({ commit }, { id }) {
    const response = await this._vm.$http.get(`/restapi/staticroutes/${id}`);
    commit("setSelectedRoute", response.data);
    commit("updateStaticRoute", response.data);
  },

  async createStaticRoute({ commit }, { scheduledRoute }) {
    const response = await this._vm.$http.post(
      `/restapi/staticroutes/`,
      scheduledRoute
    );

    commit("addStaticRoute", response.data);
  },
  async updateStaticRoute({ commit }, { id, staticRoute }) {
    const response = await this._vm.$http.post(
      `/restapi/staticroutes/${id}`,
      staticRoute
    );
    commit("updateStaticRoute", response.data);
  },

  async deleteStaticRoute({ commit }, { id }) {
    const response = await this._vm.$http.delete(`/restapi/staticroutes/${id}`);
    commit("removeStaticRoute", response.data);
  },
};

const mutations = {
  setStaticRoutes: (state, data) => (state.list = data.data),
  setSelectedRoute: (state, data) => (state.selectedRoute = data),
  addStaticRoute: (state, data) => state.list.push(data),
  updateStaticRoute: (state, data) =>
    (state.list = state.list.map((route) => {
      if (route.id === data.id) return { ...route, ...data };
      return route;
    })),
  removeStaticRoute: (state, data) =>
    (state.list = state.list.filter((report) => report.id !== data.id)),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
